import React, { useState, useImperativeHandle, forwardRef } from 'react'

//images
import closeIcon from '../../../../assets/images/profile/topic-info/close.png'

function VideoInfo(props, ref) {
    const initialState = {
        topicNumber: '',
    }
    const [state, setState] = useState({
        blur: false,
        popup: false,
        ...initialState,
        info: [
            {
                number: 1.2,
                list: <>
                    <li>
                        <b>1</b> Какво е пътно превозно средство;
                    </li>
                    <li>
                        <b>2</b> Кои са моторни превозни средства;
                    </li>
                    <li>
                        <b>3</b>Какви биват автомобилите според предназначението си;
                    </li>
                    <li>
                        <b>4</b> Какво е предназначението на ремаркетата и полуремаркетата;
                    </li>
                    <li>
                        <b>5</b> Кое е извънгабаритно и кое бавнодвижещо превозно средство;
                   </li>
                    <li>
                        <b>6</b> Специфична терминология свързана с пътните превозни средства.
                    </li>
                </>
            },
            {
                number: 1.3,
                list: <>
                    <li>
                        <b>1</b> Как са разделени категориите на водачите;
                    </li>
                    <li>
                        <b>2</b> Какви са специфичните особености на всяка отделна категория;
                    </li>
                    <li>
                        <b>3</b> Кои са най-важните особености, с които да запомните дадена категория.
                    </li>
                </>
            },
            {
                number: 1.4,
                list: <>
                    <li>
                        <b>1</b> Кога най-рано може да се придобие свидетелство за управление на моторно превозно средство;
                    </li>
                    <li>
                        <b>2</b> Кои категории може да се придобият след навършване на 18 години;
                    </li>
                    <li>
                        <b>3</b> При какви условия може да се придобие категория C;
                    </li>
                    <li>
                        <b>4</b> Кои категории се придобиват след навършени 24 години.
                    </li>
                </>
            },
            {
                number: 1.5,
                list: <>
                    <li>
                        <b>1</b> Какво е път отворен за обществено ползване;
                    </li>
                    <li>
                        <b>2</b> Кои елементи включва пътното платно;
                    </li>
                    <li>
                        <b>3</b> Каква е разликата между пътна лента и платно за движение;
                    </li>
                    <li>
                        <b>4</b> Кои елементи се явяват граница на платното за движение;
                    </li>
                    <li>
                        <b>5</b> Какво е разделителна ивица и какво остров на платното за движение;
                    </li>
                    <li>
                        <b>6</b> Кои са двата вида видимост и по какво се различават.
                    </li>
                </>
            }
        ]
    })

    useImperativeHandle(ref, () => ({
        open: topicNumber => handleOpen(topicNumber),
        close: () => handleClose()
    }))

    const handleOpen = topicNumber => {
        document.querySelector('body').style.overflow = 'hidden'
        document.querySelector('html').style.overflow = 'hidden'

        setState(state => ({
            ...state,
            blur: true,
            topicNumber
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                popup: true
            }))
        }, 50)
    }

    const handleClose = () => {
        document.querySelector('body').style.overflow = 'initial'
        document.querySelector('html').style.overflow = 'initial'

        setState(state => ({
            ...state,
            popup: false
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                blur: false,
                ...initialState
            }))
        }, 100)
    }

    return (
        <div id="overlay" className={`topic-info-overlay ${state.blur ? 'visible' : ''}`}>
            <div className={`box topic-info ${state.popup ? 'show' : ''}`}>
                <img
                    src={closeIcon}
                    className="close"
                    alt="Затваряне"
                    title="Затваряне"
                    onClick={handleClose}
                    style={{ filter: 'invert(65%) sepia(16%) saturate(313%) hue-rotate(154deg) brightness(91%) contrast(91%)' }}
                />
                <p>
                    В тази тема ще научиш:
                </p>
                <ul>
                    {state.info.find(i => i.number == state.topicNumber)?.list || <></>}
                </ul>
            </div>
        </div >
    )
}

export default forwardRef(VideoInfo)